import React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import sxStyles from "./Spinner.style";
const Spinner = ({ isFixed = false, hasBackDrop = false, onClose, ...other }) => {
    if (hasBackDrop) {
        return (React.createElement(Backdrop, { sx: (theme) => sxStyles(theme).backdrop, onClick: onClose, open: true },
            React.createElement(CircularProgress, null)));
    }
    return (React.createElement(Box, { sx: (theme) => ({
            ...sxStyles(theme).spinner,
            ...(isFixed && sxStyles(theme).isFixed),
        }), ...other },
        React.createElement(CircularProgress, null)));
};
export default Spinner;
//# sourceMappingURL=Spinner.js.map